<template>
	<div class="IdentityCompanyInfo">
		<div class="header_ContentBox p-l-10 p-r-10" >
			<i class="zb zb-tubiao- Icon"></i>
			<span class="p-l-10 p-r-10">/</span>
			<span class="header_text">人员维护</span>

		</div>
	</div>
</template>

<script>
	import {
		common
	} from '../../static/tool.js';
	export default {
		name: 'IdentityCompanyInfo',
		data() {
			return {
				url: common.url,
				windowSizeHeight: document.documentElement.clientHeight, //浏览器可视化窗口的大小
			}
		},
		mounted() {
			this.startResult();
		},
		methods: {
			startResult() {

			},

		}
	}
</script>

<style scoped>
	.IdentityCompanyInfo {
		height: 2000px;
		background-color: #FFFFFF;
	}
</style>



// WEBPACK FOOTER //
// src/components/PersonMaintain.vue